import styled from "styled-components"

const List = styled.div`
  background-color: ${({theme}) => theme.colors.greys.white};
  padding: 6px;
`

export default List
